var followmeAPILegacy = require("./FollowmeAPILegacy");
var followmeAPIv2 = require("./FollowmeAPIv2");

function FollowMeAPIFactory() {
}

FollowMeAPIFactory.getExplicit = function (appMode) {
  switch(appMode) {
    case CONSTANTS.APP_MODE_NORMAL:
      return followmeAPIv2;
    case CONSTANTS.APP_MODE_LEGACY:
    default:
      return followmeAPILegacy;
  }
};

FollowMeAPIFactory.get = function () {
  var appMode = window.storage.getAppMode();

  if(appMode === null) {
    window.storage.clearToken();
    window.location = './index.html';
    throw new Error("No app mode defined. Please refresh the application");
  }

  return this.getExplicit(appMode)
};

if(typeof window !== "undefined") window.followmeAPI = FollowMeAPIFactory;
module.exports = FollowMeAPIFactory;
